import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { Address, Contact, Copy, Customer, CustomerInfo, Edituser, EmailBox, Phone, Shipping, ShippingID, ShippingMethod, Users, View } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { exportDataExcel, fomateDate, handleCopy } from '../../utils/fomateDate';
import {

    MenuItem,
    Menu,
    Button,
    Paper,
    Typography,
    Box,
    Divider, Grid,
    Chip
} from "@mui/material";
import { ArrowDropDown, Close, Opacity, Refresh } from '@mui/icons-material';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import UserHeader from '../../component/reusable/UserHeader';
import CancelModal from '../../component/reusable/cancelModal/CancelModal';
import { bomOrderDetailsThunk, setbomOrderrefresh } from '../../redux/bomOrderSlice';
import BomListTable from '../../component/bomComps/BomListTable/BomListTable';
import styless from '../../component/bomComps/BomListTable/bomListTable.module.css';
import { getMatchedProductsThunk, getSuppliersThunk } from '../../redux/bomSlice';
import SuppliersQuote from '../bom/SuppliersQuote';
import { wizardOrderDetailsThunk } from '../../redux/wizardOrderSlice';
import GstSummary from '../../component/reusable/GstSummary';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const New = styled(Chip)(({ theme }) => ({
    backgroundColor: '#4A4C561A',
    color: '#4A4C56',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: '#F86624',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));


const Cancelled = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: 'red',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
    backgroundColor: '#EAF8FF',
    color: '#2BB2FE',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
    backgroundColor: '#E9FAF7',
    color: '#1A9882',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));


const ActionCancelButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: '#F43224',
    },
}));


const status = [
    "NEW", "PROCESSING", "PENDING", "SHIPPED", "DELIVERED"
]

const WizardOrderDetails = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [cancelModal, setCancelModal] = useState(false)
    const open = Boolean(anchorEl);
    const { macthedProducts, suppliers } = useSelector((state) => state.bom)
    const [showSupplier, setShowSupplier] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(null)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const { loading, refresh, orderDetails } = useSelector((state) => state.wizardOrder);

    const [productData, setProductData] = useState([]);


    const dispatch = useDispatch()
    const { id } = useParams()


    useEffect(() => {
        const partList = orderDetails?.partList || []
        setProductData(partList)

        // Quote price / MOQ are saved on the wizard enquiry; fill them in when the order doesn't carry them
        const enquiryId = orderDetails?.enquiryId?._id || orderDetails?.enquiryId
        const isMissingQuote = partList.some((part) => !part?.quotePrice || !part?.moq)
        if (!enquiryId || !isMissingQuote) return

        let isActive = true
        api.getwizardDetails(enquiryId)
            .then((response) => {
                if (!isActive) return
                const enquiryParts = response?.data?.data?.partList || []
                setProductData(partList.map((part) => {
                    const enquiryPart = enquiryParts.find((item) => item?.productNumber === part?.productNumber)
                    if (!enquiryPart) return part
                    return {
                        ...part,
                        quotePrice: part?.quotePrice || enquiryPart?.quotePrice,
                        moq: part?.moq || enquiryPart?.moq,
                    }
                }))
            })
            .catch((err) => console.log(err))

        return () => {
            isActive = false
        }
    }, [orderDetails])

    useEffect(() => {
        dispatch(getMatchedProductsThunk(productData))
    }, [productData])

    useEffect(() => {
        dispatch(wizardOrderDetailsThunk(id))
    }, [refresh])

    const handleClose = (status) => {
        if (status) {
            changeStatus(status)
        }
        setAnchorEl(null);
    };




    const changeStatus = async (status) => {
        const datas = {
            id: id,
            status: status
        }
        try {
            const { data } = await api.updatewizardOrderStatus(datas)
            if (data) {
                toast.success('status updated succesfully')
                dispatch(setbomOrderrefresh())
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        } finally {
            setCancelModal(false)
        }
    }



    // console.log(orderDetails);


    const exportOrderDetails = async () => {

        const exportdata = {
            'id': orderDetails?._id || '-',
            'customer Name': orderDetails?.userId?.fullName || '-',
            'Customer Email': orderDetails?.userId?.email || '-',
            // 'productNumbers': orderDetails.products
            //     .flatMap((product) =>
            //         product.productDetails?.productOverview?.productNumber || []
            //     )
            //     .join(", "),
            'Sub Total': orderDetails?.priceBreakup?.subTotal || '-',
            'Tax': orderDetails?.priceBreakup?.tax || '-',
            'Other Charges': orderDetails?.priceBreakup?.otherCharges || '-',
            'Total': orderDetails?.priceBreakup?.total || '-',
            'Status': orderDetails?.status || '-',
            'CreatedAt': fomateDate(orderDetails?.createdAt)
        }
        console.log("expo", exportdata);
        // console.log("orderde", orderDetails);

        exportDataExcel([exportdata], "ordersdetails")
    }


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Loading....
            </div>
        )
    }


    const updatedProducts = macthedProducts?.map(product => {
        const foundProduct = productData?.find(p => p?.productNumber === product?.productNumber);
        return {
            ...product,
            quantity: foundProduct ? foundProduct.quantity : 0 // Default to 0 if not found
        };
    });






    const handleChange = (index, field, value) => {
        const updatedProducts = [...productData];
        updatedProducts[index] = { ...updatedProducts[index], [field]: value }; // Add field dynamically
        setProductData(updatedProducts);
    };

    // Delete a product
    const handleDelete = (index) => {
        setProductData(productData.filter((_, i) => i !== index));
    };

    // Refresh a row (reset the input fields)
    const handleRefresh = (index) => {
        setProductData((prevProducts) => {
            const updatedProducts = [...prevProducts];
            updatedProducts[index] = { _id: prevProducts[index]._id, productNumber: prevProducts[index]?.productNumber }; // Keep only `_id`
            return updatedProducts;
        });
    };


    const handleView = (index) => {
        setSelectedIndex(index)
        const product = productData[index];
        // enquiryId is needed so the vendors' quoted price / MOQ / date code come back
        const params = new URLSearchParams({
            productNumber: product?.productNumber || '',
            quantity: product?.quantity ?? '',
            enquiryId: orderDetails?.enquiryId?._id || orderDetails?.enquiryId || '',
            manufacturer: product?.manufacturer || '',
        })
        dispatch(getSuppliersThunk(`?${params.toString()}`))
        setShowSupplier(true)
    }

    console.log(macthedProducts);

    return (
        <>

            <UserHeader
                index={`Order #${orderDetails?._id}`}
                root="Dashboard"
                buttonText={'Add Vendor'}
                showHeader={'orderDetails'}
                exportData={exportOrderDetails}
            />
            <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
                <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography
                            sx={{
                                color: 'rgba(29, 31, 44, 1)',
                                fontSize: '20px',
                                fontWeight: '600',
                                fontFamily: `'Public Sans', sans-serif`,
                            }}>
                            Order #{orderDetails?._id}
                        </Typography>
                        <Typography style={{
                            marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
                            color: '#01A1FE',
                            background: "#EFF9FF",

                        }}>
                            {orderDetails?.status === "NEW" ? (
                                <New label="New" size="small" />
                            ) : orderDetails?.status === "DELIVERED" ? (
                                <Delivered label="Delivered" size="small" />
                            ) : orderDetails?.status === "PROCESSING" ? (
                                <Processing label="Processing" size="small" />
                            ) : orderDetails?.status === "CANCELLED" ? (
                                <Cancelled label="Cancelled" size="small" />
                            ) : (
                                <Shiped label="shipped" size="small" />
                            )}
                        </Typography>
                    </div>
                    <div>

                        <ActionCancelButton
                            sx={{
                                color: '#fff',
                                border: '1px solid #F43224',
                                background: '#F43224',
                                borderRadius: '8px',
                            }}
                            onClick={() => setCancelModal(!cancelModal)}
                        >Cancel order
                        </ActionCancelButton>

                        <ActionButton
                            onClick={handleClick}
                            sx={{
                                color: '#667085',
                                border: '1px solid #E0E2E7',
                                background: '#fff',
                                borderRadius: '8px',
                            }}
                        >
                            Status
                            <ArrowDropDown />
                        </ActionButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleClose('')}
                            MenuListProps={{
                                'aria-labelledby': 'status-button',
                            }}
                        >
                            {
                                status?.map((i) => (
                                    <MenuItem onClick={() => handleClose(i)}
                                        sx={{
                                            borderBottom: '1px solid #E6E1E5',
                                            fontSize: '14px',
                                            color: '#667085',
                                            textTransform: 'capitalize'
                                        }}>
                                        {i}
                                    </MenuItem>
                                ))
                            }


                        </Menu>
                    </div>
                </div>

                {loading ? <div>Please wait...</div> :
                    <Box maxWidth="lg">

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <CustomerInfo />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Customer Info
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                                        <Customer />
                                        <Box style={{ marginLeft: '8px', }}>
                                            <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                Company
                                            </Typography>
                                            <Box>
                                              {/* Company first; the contact person's name below it */}
                                              <Typography style={{ color: '#0C0D0F', fontSize: '14px', fontWeight: 600 }}>
                                                {orderDetails?.userId?.companyName || orderDetails?.userId?.fullName || 'Customer unavailable'}
                                              </Typography>
                                              {orderDetails?.userId?.companyName && orderDetails?.userId?.fullName && (
                                                <Typography style={{ color: '#727A90', fontSize: '13px' }}>{orderDetails.userId.fullName}</Typography>
                                              )}
                                            </Box></Box>
                                    </Box>
                                </Paper>
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <Contact />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Contact
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <EmailBox />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Email
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.email}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.email)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Phone />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Phone Number
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.phone}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.phone)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>

                            {/* <Grid item xs={12} md={6}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Payment />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Payment
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <ShippingID />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Payment ID
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          490392238192<br />
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(vendorDetails?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Billing />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Payment Method
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          VISA
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Billing />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Billing Address
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {vendorDetails?.billingAddress?.factoryUnits}<br />
                          {vendorDetails?.billingAddress?.streetAddress}, {vendorDetails?.billingAddress?.state},{vendorDetails?.billingAddress?.country} - {vendorDetails?.billingAddress?.zipCode}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid> */}

                            <Grid item xs={12} md={6}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <Shipping />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Shipping
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <ShippingID />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping ID
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    SHP1092311<br />
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.phone)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <ShippingMethod />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping Method
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    Regular
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Address />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping Address
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>

                                                    {orderDetails?.shippingAddress?.factoryUnits}<br />
                                                    {orderDetails?.shippingAddress?.streetAddress}, {orderDetails?.shippingAddress?.state} - {orderDetails?.shippingAddress?.zipCode},{orderDetails?.shippingAddress?.country}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* <BomQuote /> */}
                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                                <Box display="flex" alignItems="center" >
                                    <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                                        {productData?.length} Products
                                    </Typography>
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
                                        Quoted date: {fomateDate(orderDetails?.createdAt)}
                                    </Typography>
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: orderDetails?.status === "NEW" ? "#4A4C56" : orderDetails?.status === "QUOTED" ? "#00B789" : "#1A9882" }}>
                                        {orderDetails?.status}
                                    </Typography>

                                </Box>

                            </Box>
                            <div className={styless.quoteTables}>
                                <div className={styless.quoteProductsPane}>

                                    <BomListTable
                                        products={updatedProducts}
                                        show={true}
                                    />


                                </div>
                                <div className={`${styless.quoteInputsPane} ${styless.orderQuoteInputsPane}`}>
                                    <table className={`${styless.productTable22} ${styless.quoteInputsTable}`}>
                                        <thead className={styless.productTableHead22}>
                                            <tr style={{ height: 30 }}>
                                                <th>Quote Price</th>
                                                <th>MOQ</th>
                                                <th className={styless.quoteActionHeader}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productData?.map((product, index) => (
                                                <tr key={product?._id} style={{ height: 100 }}>
                                                    <td className={styless.tdBorder}>
                                                        <input
                                                            type="text"
                                                            placeholder="-"
                                                            className={`${styless.dataInput} ${styless.quoteReadonlyInput}`}
                                                            value={product?.quotePrice || ""} // Default empty if not present
                                                            onChange={(e) => handleChange(index, "quotePrice", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td className={styless.tdBorder}>
                                                        <input
                                                            type="text"
                                                            placeholder="-"
                                                            className={`${styless.dataInput} ${styless.quoteReadonlyInput}`}
                                                            value={product?.moq || ""} // Default empty if not present
                                                            onChange={(e) => handleChange(index, "moq", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </td>

                                                    <td className={`${styless.tdBorder} ${styless.quoteActionCell}`}>
                                                        <div className={styless.quoteActions}>
                                                            <button type="button" className={styless.quoteActionButton} aria-label="View product" onClick={() => handleView(index)}>
                                                                <View />
                                                            </button>
                                                            {/* <div><Edituser /></div>
                                                        <div onClick={() => handleRefresh(index)} >
                                                            <Refresh />
                                                        </div>
                                                        <div onClick={() => handleDelete(index)}>
                                                            <Close />
                                                        </div> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div style={{ display: 'flex', justifyContent: "flex-end", gap: "20px", padding: "20px" }}> */}
                            {/* <button className={styless.quoteBtn}>Cancel</button> */}
                            {/* <button className={styless.addBtn} onClick={handleSubmit}>Submit Quote</button> */}
                            {/* </div> */}
                        </Paper>

                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <GstSummary parts={productData} />
                        </Paper>
                        <CancelModal
                            onDelete={() => changeStatus('CANCELLED')}
                            isOpen={cancelModal}
                            onClose={() => setCancelModal(false)}
                        />
                        {showSupplier &&
                            <div style={{ position: 'absolute', top: '20%', left: '30%', zIndex: 1, width: '100%' }}>
                                <SuppliersQuote
                                    data={suppliers?.data}
                                    loadings={suppliers?.loading}
                                    setShowSupplier={setShowSupplier}
                                    enquiryType={'WIZARD'}
                                    handleView={handleView}
                                    selectedIndex={selectedIndex}
                                    showEnquiryAction={false}
                                />
                            </div>
                        }
                    </Box>
                }
            </div>
        </>
    );
};

export default WizardOrderDetails;
